import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Index from "./../js/index";
import MaintainCompany from "./../js/maintainCompany";
import MaintainBuyers from "./../js/maintainBuyers";
import MaintainBuyersPO from "./../js/maintainBuyersPo";
import MaintainStaff from "./../js/maintainStaff";
import MaintainMachine from "./../js/maintainMachine";
import MaintainDesignColor from "./../js/maintainDesignColor";
import Season from "./../js/season";
import City from "./../js/city";
import MaintainWeaver from "./../js/maintainWeaver";
import MaintainTransporter from "./../js/maintainTransporter";
import ShowAvailability from "./../js/maintainShowAvailability";
import Availability from "./../js/availability";
import MaintainQuotes from "./../js/maintainQuotes";
import InternalPO from "./../js/internalPo";
import WeaverLogin from "./../js/weaverLogin.js";
import Weaver from "./../js/weaver.js";
import PO from "./../js/po.js";
import CSProgressUpdate from "./../js/csProgressUpdate.js";
import CSDispatch from "./../js/csDispatch.js";
import WVRProgressUpdate from "./../js/wvrProgressUpdate.js";
import WVRDispatch from "./../js/wvrDispatch.js";
import WVRDone from "./../js/wvrDone.js";
import IpoProgressUpdate from "./../js/wvrPOProgressUpdate.js";
import Quality from "./../js/quality.js";
import Construction from "./../js/construction.js";
import YarnCount from "./../js/yarnCount.js";
import Width from "./../js/width.js";
import Report from "./../js/report.js";
import StockLocation from "./../js/stockLocation.js";
import Stock from "./../js/stock.js";
import DispatchSummary from "./../js/dispatchSummary.js";
import BuyerDispatch from "./../js/buyerDispatch.js";
import OperationalDashboard from "./../js/operationalDashboard.js";
import Factory from "./../js/factory.js";
import WorkSummary from "./../js/workSummary.js";
import PendingChanges from "./../js/pendingChanges.js";
import WvrPendingChanges from "./../js/wvrPendingChanges.js";
import mstStock from "./../js/mstStock.js";
import issueStock from "./../js/issueStock.js";
import NotFound from "./NotFound";
import CancelledIpoDesignReport from "./../js/cancelledIpoDesignReport";
import OnholdIpoDesignReport from "./../js/onholdIpoDesignReport";
import BuyerAppSetup from "./../js/BuyerAppSetup";
import AdminDashboard from "./Admin/adminDashboard";
import CsOpenIPO from "./csOpenIPO.js";


/* LOCAL */
/* window.WVRURL = 'http://localhost:3000/wvr';
  window.CSURL = 'http://localhost:3000/cs';
  window.httpURL = "https://65.0.190.204:8098/cs";
  window.reportURL = "https://65.0.190.204:8098/cs/quo/report";
*/ 
// 3.109.142.112
//  TEST WITH IP AND PORT
/* window.httpURL = "http://3.108.193.135:8098/cs";
window.reportURL = "http://3.108.193.135:8098/cs/quo/report";
window.CSURL = 'http://3.108.193.135:5000/cs';
window.WVRURL = 'http://3.108.193.135:5000/wvr'; */
/* PROD WITH IP AND PORT
window.httpURL = "http://65.1.246.38:8098/cs";
window.CSURL = "http://65.1.246.38:5000/cs";
window.WVRURL = "http://65.1.246.38:5000/wvr";
window.reportURL = "http://65.1.246.38:8098/cs/quo/report";
*/
/* PROD WITH DOMAIN AND PORT 
window.httpURL = "http://cs.kmsgtech.com:8098/cs";
window.CSURL = 'http://cs.kmsgtech.com:5000/cs';
window.WVRURL = 'http://cs.kmsgtech.com:5000/wvr';
window.reportURL = "http://cs.kmsgtech.com:8098/cs/quo/report";
 */
/* PROD WITH DOMAIN */
window.httpURL = "https://erp.chandrasilks.com:8097/cs";
window.CSURL = 'https://erp.chandrasilks.com/cs';
window.WVRURL = 'https://erp.chandrasilks.com/wvr';
window.reportURL = "https://erp.chandrasilks.com:8097/cs/quo/report";
 

class Routers extends Component {
  render() {
    return (
      <Router>
        <Switch style={{ height: "100%" }}>
          <Route path="/cs" basename="/Index" exact component={Index} />
          
          
          <Route
            path="/cs/maintainCompany"
            basename="/Index"
            component={MaintainCompany}
          />
          <Route
            path="/cs/maintainBuyers"
            basename="/Index"
            component={MaintainBuyers}
          />
          <Route
            path="/cs/maintainBuyersPO"
            basename="/Index"
            component={MaintainBuyersPO}
          />
          <Route
            path="/cs/maintainStaff"
            basename="/Index"
            component={MaintainStaff}
          />
          <Route
            path="/cs/maintainMachine"
            basename="/Index"
            component={MaintainMachine}
          />
          <Route
            path="/cs/maintainDesignColor"
            basename="/Index"
            component={MaintainDesignColor}
          />
          <Route
            path="/cs/maintainWeaver"
            basename="/Index"
            component={MaintainWeaver}
          />
          <Route
            path="/cs/maintainTransporter"
            basename="/Index"
            component={MaintainTransporter}
          />
          <Route path="/cs/factory" basename="/Index" component={Factory} />
          <Route path="/cs/season" basename="/Index" component={Season} />
          <Route path="/cs/city" basename="/Index" component={City} />
          <Route
            path="/cs/availability"
            basename="/Index"
            component={ShowAvailability}
          />
          <Route
            path="/cs/maintainQuotes"
            basename="/Index"
            component={MaintainQuotes}
          />
          <Route
            path="/cs/internalPO"
            basename="/Index"
            component={InternalPO}
          />
          <Route
            path="/cs/progressUpdate"
            basename="/Index"
            component={CSProgressUpdate}
          />
          <Route path="/cs/dispatch" basename="/Index" component={CSDispatch} />
          <Route path="/cs/quality" basename="/Index" component={Quality} />
          <Route
            path="/cs/construction"
            basename="/Index"
            component={Construction}
          />
          <Route path="/cs/yarnCount" basename="/Index" component={YarnCount} />
          <Route
            path="/cs/operationalDashboard"
            exact
            component={OperationalDashboard}
          />
          <Route path="/cs/report" basename="/Index" component={Report} />
          <Route
            path="/cs/dispatchSummary"
            basename="/Index"
            component={DispatchSummary}
          />
          <Route path="/cs/width" basename="/Index" component={Width} />
          <Route
            path="/cs/stockLocation"
            basename="/Index"
            component={StockLocation}
          />
          <Route path="/cs/stock" basename="/Index" component={Stock} />
          <Route path="/cs/mstStock" basename="/Index" component={mstStock} />
          <Route
            path="/cs/issueStock"
            basename="/Index"
            component={issueStock}
          />
          <Route path="/cs/buyerDispatch" exact component={BuyerDispatch} />
          <Route
            path="/cs/workSummary"
            basename="/Index"
            component={WorkSummary}
          />
          <Route
            path="/cs/pendingChanges"
            basename="/Index"
            component={PendingChanges}
          />

          <Route
            path="/cs/cancelledPoDesign"
            basename="/Index"
            component={CancelledIpoDesignReport}
          />
          <Route
            path="/cs/holdPoDesign"
            basename="/Index"
            component={OnholdIpoDesignReport}
          />
          <Route
            path="/cs/buyerAppSetup"
            basename="/Index"
            component={BuyerAppSetup}
          />
          <Route path="/wvr/" basename="/Index" exact component={WeaverLogin} />
          <Route path="/wvr/weaver" basename="/Index" component={Weaver} />
          <Route path="/wvr/po" basename="/Index" component={PO} />
          <Route
            path="/wvr/availability"
            basename="/Index"
            component={Availability}
          />
          <Route
            path="/wvr/update"
            basename="/Index"
            component={IpoProgressUpdate}
          />
          <Route
            path="/wvr/progressUpdate"
            basename="/Index"
            component={WVRProgressUpdate}
          />
          <Route
            path="/wvr/dispatch"
            basename="/Index"
            component={WVRDispatch}
          />
          <Route path="/wvr/workDone" basename="/Index" component={WVRDone} />
          <Route
            path="/wvr/wvrPendingChanges"
            basename="/Index"
            component={WvrPendingChanges}
          />
          <Route
            path="/adminDashboard"
            basename="/Index"
            component={AdminDashboard}
          />
          <Route path="/cs/openIpo" basename="/Index" component={CsOpenIPO} />
          <Route component={NotFound} />
        </Switch>
      </Router>
    );
  }
}

export default Routers;
